document.addEventListener("DOMContentLoaded", () => {
  const circles = document.querySelectorAll(".circulo");
  circles.forEach(function (e) {
    e.addEventListener("click", function (e) {
      circles.forEach(function (e) {
        e.querySelector(".container-card").classList.add("hide");
      });
      e.target.querySelector(".container-card").classList.remove("hide");
    });
  });
});
